import styles from "./ArticleRubric.module.scss";
import { ArticleLayout, ArticleRubricFragment } from "types/api";
import { gql } from "utils/urql";
import cx from "classnames";

const ArticleRubric = ({
  primaryCategory,
  layout,
}: ArticleRubricFragment & { layout: ArticleLayout }) => {
  if (!primaryCategory) return null;
  return (
    <div
      className={cx(styles.root, layout === "feature" && styles.feature)}
      id="rubric"
    >
      {primaryCategory.url ? (
        <a
          className={styles.link}
          href={primaryCategory.url}
          data-action="click link - section rubric"
          data-label={primaryCategory.url}
        >
          {primaryCategory.displayName}
        </a>
      ) : (
        primaryCategory.displayName
      )}
    </div>
  );
};

ArticleRubric.fragment = gql`
  fragment articleRubric on Article {
    primaryCategory {
      __typename
      ... on Category {
        displayName
        url
      }
      ... on Channel {
        displayName
        url
      }
      ... on EditorialProject {
        displayName
        url
      }
    }
  }
`;

export default ArticleRubric;
